import { render, staticRenderFns } from "./ProjectMembers.vue?vue&type=template&id=725f628c&scoped=true&"
import script from "./ProjectMembers.vue?vue&type=script&lang=js&"
export * from "./ProjectMembers.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMembers.vue?vue&type=style&index=0&id=725f628c&scoped=true&lang=css&"
import style1 from "./ProjectMembers.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725f628c",
  null
  
)

export default component.exports